// src/pages/NotFound.jsx
import React from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function NotFound() {
  const { pathname } = useLocation();

  return (
    <div className="d-flex flex-column align-items-center justify-content-center vh-100 text-center">
      <h1 className="display-4 fw-bold mb-2">404</h1>
      <h2 className="h4 fw-semibold mb-3">Whoops – nothing lives at <code>{pathname}</code></h2>

      <p className="text-muted mb-4">
        The page you’re looking for was moved, removed, renamed, or never existed.
      </p>

      <Link to="/" className="btn btn-primary">
        <i className="bi bi-house-fill me-2" />
        Back to home
      </Link>
    </div>
  );
}
